<template>
  <div class="mt-2 mx-3">
    <div>
      <v-sheet class="rounded-0 shadow-none">
        <v-row justify="center">
          <v-col
            cols="12"
            class="mt-1 no-space"
            align-self="center"
            md="6"
            sm="6"
          >
            <v-chip-group
              v-model="selection"
              active-class="light-green darken-3 white--text"
              class="mx-auto chip-selector"
              center-active
              @change="getFilterADP(selection)"
              mandatory
            >
              <v-chip
                v-for="selection in position"
                :key="selection"
                :value="selection"
              >
                {{ selection }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-sheet>
      <div v-if="loadingStatus">
        <v-skeleton-loader
          :loading="loadingStatus"
          class="mb-3 mt-4"
          type="list-item-avatar-two-line,table,paragraph"
          elevation="2"
        >
        </v-skeleton-loader>
      </div>

      <div v-else>
        <!--//? Studs table-->
        <div class="mt-5">
          <v-sheet elevation="3" class="mt-0 mt-md-4">
            <div>
              <v-data-table
                dense
                :headers="headers"
                :items="getPlayers"
                item-key="Name"
                class="elevation-1 adp-table"
                :footerProps="footerProps"
                mobile-breakpoint="0"
                sort-by="AverageDraftPosition"
              >
                <!-- header -->
                <template
                  v-for="h in headers"
                  v-slot:[`header.${h.value}`]="{ headers }"
                >
                  <v-tooltip bottom :key="h.text">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{ h.text }}</span>
                    </template>
                    <span>{{ h.hint }}</span>
                  </v-tooltip>
                </template>
                <!-- header -->

                <!-- profile image -->
                <template v-slot:item.PhotoUrl="{ item }">
                  <v-avatar width="37" height="48">
                    <img :src="item.PhotoUrl" />
                  </v-avatar>
                </template>
                <!-- profile image ends -->

                <!-- player name -->
                <template v-slot:item.Name="{ item }">
                  <router-link
                    :to="{
                      name: 'PlayerDetail',
                      params: {
                        playerId: item.PlayerID,
                        SportId: item.SportId,
                      },
                    }"
                    style="text-decoration: none"
                    class="caption"
                  >
                    {{ item.Name }}
                  </router-link>
                </template>
                <!-- player name ends -->

                <template v-slot:item.AverageDraftPosition2QB="{ item }">
                  <p v-if="!item.AverageDraftPosition2QB">0</p>
                  <p v-else>{{ item.AverageDraftPosition2QB }}</p>
                </template>

                <template v-slot:item.AverageDraftPositionDynasty="{ item }">
                  <p v-if="!item.AverageDraftPositionDynasty">0</p>
                  <p v-else>{{ item.AverageDraftPositionDynasty }}</p>
                </template>

                <template v-slot:item.AuctionValuePPR="{ item }">
                  <p v-if="!item.AuctionValuePPR">0</p>
                  <p v-else>{{ item.AuctionValuePPR }}</p>
                </template>

                <template v-slot:item.FantasyPointsPPR="{ item }">
                  <p v-if="!item.FantasyPointsPPR">0</p>
                  <p v-else>{{ item.FantasyPointsPPR }}</p>
                </template>
              </v-data-table>
            </div>
          </v-sheet>
        </div>
        <!--//? studs table ends -->
      </div>
    </div>

    <!-- update Modal -->
    <upgrade-modal-2
      v-if="UpgradeModal"
      :UpgradeModal="UpgradeModal"
      @closeModal="goBack"
    />
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import UpgradeModal2 from "@/components/Modal/UpgradeModal2.vue";

export default {
  name: "MlbAdp",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  components: { UpgradeModal2 },

  data: () => ({
    footerProps: { "items-per-page-options": [25, 35, 70, -1] },
    UpgradeModal: false,
    userId: localStorage.getItem("user"),
    position: ["Overall", "C", "1B", "2B", "3B", "SS", "OF", "P"],
    selection: "Overall",

    headers: [
      { text: "Player", value: "Name", hint: "Name" },
      { text: "Team", value: "Team", hint: "Team" },
      {
        text: "Position",
        value: "Position",
        hint: "position",
        align: "center",
      },
      {
        text: "AVG",
        value: "AverageDraftPosition",
        hint: "Average Draft Position",
      },
      {
        text: "Auction Value",
        value: "AuctionValue",
        hint: "Auction Value",
      },

      {
        text: "FP FanDuel",
        value: "FantasyPointsFanDuel",
        hint: "FantasyPointsFanDuel",
      },
      {
        text: "FP Fantasy Draft",
        value: "FantasyPointsFantasyDraft",
        hint: "FantasyPointsFantasyDraft",
      },
      {
        text: "FP Batting",
        value: "FantasyPointsBatting",
        hint: "FantasyPointsBatting",
      },
    ],
  }),

  created() {
    this.fetchADPData();
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  computed: {
    ...mapState("MlbModule", ["mlb_adp", "loadingStatus"]),
    ...mapGetters("MlbModule", ["getFilterADP"]),

    getPlayers() {
      if (this.mlb_adp?.players) {
        return this.getFilterADP(this.selection);
      }
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    fetchADPData() {
      this.$store.dispatch("MlbModule/getADP");
    },
  },
};
</script>

<style scoped>
.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}

.v-chip-group >>> .v-slide-group__content {
  padding: 4px 0;
  display: flex;
  justify-content: center;
}
</style>
